<template>
  <v-container fluid>
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <v-form @submit.prevent="handleSubmit(salvar)">
        <v-row>
          <v-col cols="12">
            <base-material-card color="primary" icon="mdi-database-check" inline class="px-5 py-3" :title="titulo">
              <v-row class="mt-5">
                <v-col md="6" cols="12">
                  <validation-provider v-slot="{ errors }" vid="nome" name="Nome" :rules="{ required: true, max: 150 }">
                    <v-text-field
                      id="validacao-customizada-nome"
                      v-model="formulario.nome"
                      label="Nome"
                      outlined
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
                <v-col md="6" cols="12">
                  <validation-provider v-slot="{ errors }" vid="entidades" name="Entidades" :rules="{ required: true }">
                    <v-autocomplete
                      id="validacao-customizada-entidades"
                      v-model="formulario.entidades"
                      :items="entidades"
                      :loading="loadingEntidades"
                      label="Entidades"
                      multiple
                      chips
                      small-chips
                      deletable-chips
                      outlined
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6" cols="12">
                  <validation-provider
                    v-slot="{ errors }"
                    vid="campo"
                    name="Campo"
                    :rules="{ required: true, regex: /^[A-Z0-9_ :()\-><.,\/+=]{1,50}$/ }"
                  >
                    <v-text-field
                      id="validacao-customizada-campo"
                      v-model="formulario.campo"
                      label="Campo"
                      outlined
                      :hint="hints.campo"
                      persistent-hint
                      class="campo-maiusculo"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
                <v-col md="6" cols="12">
                  <validation-provider
                    v-slot="{ errors }"
                    vid="nome_validacao"
                    name="Nome da Validação"
                    :rules="{ required: true, regex: /^[A-Z0-9_ :()\-><.,\/+=]{1,100}$/ }"
                  >
                    <v-text-field
                      id="validacao-customizada-nome-validacao"
                      v-model="formulario.nome_validacao"
                      label="Nome da Validação"
                      outlined
                      :hint="hints.nomeValidacao"
                      persistent-hint
                      class="campo-maiusculo"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6" cols="12">
                  <validation-provider v-slot="{ errors }" vid="tipo_ocorrencia" name="Tipo" :rules="{ required: true }">
                    <v-select
                      id="validacao-customizada-tipo-ocorrencia"
                      v-model="formulario.tipo_ocorrencia"
                      :items="['ERRO', 'AVISO']"
                      label="Tipo"
                      outlined
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
                <v-col md="6" cols="12">
                  <validation-provider v-slot="{ errors }" vid="ativo" name="Ativo">
                    <v-switch
                      id="validacao-customizada-ativo"
                      v-model="formulario.ativo"
                      label="Ativo"
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <validation-provider v-slot="{ errors }" vid="descricao" name="Descrição">
                    <v-textarea
                      id="validacao-customizada-descricao"
                      v-model="formulario.descricao"
                      label="Descrição"
                      outlined
                      rows="2"
                      no-resize
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <validation-provider v-slot="{ errors }" vid="codigo_sql" name="Código SQL" :rules="{ required: true }">
                    <v-textarea
                      id="validacao-customizada-codigo-sql"
                      v-model="formulario.codigo_sql"
                      class="ta-padding-c"
                      label="Código SQL"
                      outlined
                      rows="10"
                      no-resize
                      background-color="#EEEEEE"
                      :hint="hints.codigoSql"
                      persistent-hint
                      :error-messages="errors"
                    />
                  </validation-provider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-tooltip bottom :disabled="!motivoTesteIndisponivel">
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <v-btn
                          id="btn-testar-validacao-customizada"
                          color="secondary"
                          :disabled="Boolean(motivoTesteIndisponivel)"
                          :loading="testando"
                          @click="testarQuery()"
                        >
                          <v-icon left>mdi-play-circle-outline</v-icon>
                          Testar Query
                        </v-btn>
                      </span>
                    </template>
                    <span>{{ motivoTesteIndisponivel }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row v-if="resultadoTeste">
                <v-col cols="12">
                  <v-alert dense text type="info">
                    Consulta executada em {{ resultadoTeste.tempoMs }} ms, exibindo até 10 linhas.
                  </v-alert>
                  <v-data-table
                    id="validacao-customizada-resultado-teste"
                    :headers="headersResultadoTeste"
                    :items="resultadoTeste.linhas"
                    :items-per-page="10"
                    hide-default-footer
                    no-data-text="A query não retornou linhas."
                  />
                </v-col>
              </v-row>
            </base-material-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn id="btn-cancelar-validacao-customizada" text style="float: right" class="mr-2" @click="voltar">Cancelar</v-btn>
            <v-btn
              id="btn-salvar-validacao-customizada"
              color="primary"
              min-width="100"
              style="float: right"
              class="mr-2"
              type="submit"
              :loading="salvando"
            >
              Salvar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </validation-observer>
  </v-container>
</template>

<script>
  import ValidacoesBdgdsModelosService from '@/services/ValidacoesBdgdsModelosService';
  import EntidadesBdgdService from '@/services/EntidadesBdgdService';
  import routes from '@/store/modules/routes';

  const codigoSqlExemplo = `select
    gid as linha_invalida_id,
    cod_id as codigo_invalido,
    'Descreva o erro encontrado' as mensagem1,
    null as mensagem2
from
    {{entidade}}
where
    bdgd_versao_id = {{bdgd_versao_id}}`;

  const hints = {
    campo:
      'Campo da entidade analisado pela regra. Letras, números, espaço e _ : ( ) - > < . , / + = (máx. 50 caracteres)',
    nomeValidacao: 'Identifica a regra no Dashboard. Letras, números, espaço e _ : ( ) - > < . , / + =',
    codigoSql:
      'Use {{entidade}} no lugar da tabela e {{bdgd_versao_id}} no filtro da versão. Retorne linha_invalida_id (gid), codigo_invalido, mensagem1 e mensagem2. As palavras insert, update, delete, truncate, drop e alter table são removidas do SQL, inclusive dentro de nomes como updated_at.'
  };

  const formularioInicial = () => ({
    id: null,
    nome: '',
    descricao: '',
    entidades: [],
    campo: '',
    nome_validacao: '',
    tipo_ocorrencia: 'ERRO',
    codigo_sql: codigoSqlExemplo,
    ativo: true
  });

  export default {
    name: 'ValidacaoBdgdModeloEdit',

    data: () => ({
      loading: false,
      salvando: false,
      loadingEntidades: false,
      entidades: [],
      formulario: formularioInicial(),
      hints,
      testando: false,
      resultadoTeste: null,
      headersResultadoTeste: [
        { text: 'linha_invalida_id', value: 'linha_invalida_id' },
        { text: 'codigo_invalido', value: 'codigo_invalido' },
        { text: 'mensagem1', value: 'mensagem1' },
        { text: 'mensagem2', value: 'mensagem2' }
      ]
    }),

    computed: {
      validacaoId() {
        return this.$route.params.id;
      },
      addMode() {
        return this.validacaoId === undefined;
      },
      titulo() {
        return this.addMode ? 'Nova Validação Customizada' : 'Editar Validação Customizada';
      },
      bdgdVersaoSelecionada() {
        return this.$store.getters.getUserSelectedCompanyBdgdVersion;
      },
      motivoTesteIndisponivel() {
        if (!this.bdgdVersaoSelecionada) {
          return 'Selecione uma versão da BDGD em "Mudar Empresa", no menu lateral, para testar a query.';
        }

        if (!this.formulario.entidades.length) {
          return 'Selecione ao menos uma entidade para testar a query.';
        }

        return null;
      }
    },

    mounted() {
      this.getEntidades();

      if (this.validacaoId) {
        this.getValidacao(this.validacaoId);
      }
    },

    methods: {
      getEntidades() {
        this.loadingEntidades = true;
        EntidadesBdgdService.getEntidades()
          .then((response) => {
            this.entidades = response.data;
          })
          .finally(() => (this.loadingEntidades = false));
      },
      getValidacao(id) {
        this.loading = true;
        ValidacoesBdgdsModelosService.obter(id)
          .then(({ data }) => {
            this.formulario = { ...formularioInicial(), ...data.data, id };
          })
          .catch(() => {
            this.$toast.error('Erro ao recuperar a validação customizada.', '', { position: 'topRight' });
            this.voltar();
          })
          .finally(() => (this.loading = false));
      },
      salvar() {
        this.salvando = true;
        ValidacoesBdgdsModelosService.salvar(this.formulario)
          .then(() => {
            this.$toast.success('Validação customizada salva com sucesso.', '', { position: 'topRight' });
            this.voltar();
          })
          .catch((error) => {
            if (error.status === 422 && error.data.errors) {
              this.setErrosServidor(error.data.errors);
              this.$toast.error('Verifique os campos destacados no formulário.', '', { position: 'topRight' });
              return;
            }

            this.$toast.error('Erro ao salvar a validação customizada.', '', { position: 'topRight' });
          })
          .finally(() => (this.salvando = false));
      },
      testarQuery() {
        this.testando = true;
        this.resultadoTeste = null;

        ValidacoesBdgdsModelosService.testar(this.formulario.codigo_sql, this.formulario.entidades)
          .then(({ data }) => {
            this.resultadoTeste = {
              linhas: data.data.linhas,
              tempoMs: data.data.tempo_ms
            };
          })
          .catch((error) => {
            if (error.status === 422 && error.data.errors) {
              this.setErrosServidor(error.data.errors);
              this.$toast.error('Verifique os campos destacados no formulário.', '', { position: 'topRight' });
              return;
            }

            this.$toast.error('Erro ao testar a query.', '', { position: 'topRight' });
          })
          .finally(() => (this.testando = false));
      },
      setErrosServidor(errors) {
        const errosPorCampo = {};

        Object.keys(errors).forEach((chave) => {
          const campo = chave.replace(/\.\d+$/, '');
          errosPorCampo[campo] = [...(errosPorCampo[campo] || []), ...errors[chave]];
        });

        this.$refs.observer.setErrors(errosPorCampo);
      },
      voltar() {
        this.$router.push({ name: routes.state.appRoutes['VALIDACOES_BDGDS_MODELOS_HISTORICO'] });
      }
    },

    watch: {
      'formulario.campo'(valor) {
        if (valor && valor !== valor.toUpperCase()) {
          this.formulario.campo = valor.toUpperCase();
        }
      },
      'formulario.nome_validacao'(valor) {
        if (valor && valor !== valor.toUpperCase()) {
          this.formulario.nome_validacao = valor.toUpperCase();
        }
      }
    }
  };
</script>

<style scoped>
  .campo-maiusculo >>> input {
    text-transform: uppercase;
  }
  .ta-padding-c >>> .v-text-field__slot {
    padding: 8px;
  }
</style>
